import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { FaEnvelope } from 'react-icons/fa';



const PreviewContact = () => {
    const [previewContact, setPreviewContact] = useState(null);
    const { id } = useParams();
    const access_token = localStorage.getItem("access_token");
    const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
    };

    useEffect(() => {
        const fetchPreviewContact = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/contact-us/perview/${id}`, {
                    headers: headers,
                });
                setPreviewContact(response?.data?.contactUs);
            } catch (error) {
                console.error("Error fetching contact preview:", error);
            }
        };

        fetchPreviewContact();
    }, [id]);

    return (
        <div className="container py-5 min-vh-100 d-flex justify-content-center align-items-start bg-light">
            {previewContact ? (
                <div style={{ maxWidth: '720px', width: '100%' }}>
                    <h3 className="mb-5 text-dark border-bottom pb-3 fw-bold">
                        <FaEnvelope className="me-2 text-muted" />
                        {previewContact.subject || 'No Subject'}
                    </h3>

                    <div className="row mb-4">
                        <div className="col-md-4 text-secondary fw-semibold">Name</div>
                        <div className="col-md-8 fs-6 text-dark">{previewContact.fullname}</div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-4 text-secondary fw-semibold">Email</div>
                        <div className="col-md-8 fs-6 text-dark">{previewContact.email}</div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-4 text-secondary fw-semibold">Phone</div>
                        <div className="col-md-8 fs-6 text-dark">{previewContact.phone_number}</div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-4 text-secondary fw-semibold">Message</div>
                        <div className="col-md-8">
                            <div className="p-3 bg-white border rounded-3 shadow-sm text-muted">
                                {previewContact.message}
                            </div>
                        </div>
                    </div>

                    {previewContact.image && (
                        <div className="row mb-4">
                            <div className="col-md-4 text-secondary fw-semibold">Screenshot</div>
                            <div className="col-md-8">
                                <a
                                    href={previewContact.image}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={previewContact.image}
                                        alt="Screenshot"
                                        className="img-fluid rounded-3 shadow"
                                        style={{ maxHeight: '300px', cursor: 'pointer' }}
                                    />
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className="text-center w-100">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PreviewContact;
